import React, { useState, useEffect } from 'react'
import { DiscoveryWheelchair } from '@fs/zion-icon'
import { IconButton } from '@fs/zion-ui'
import { css } from '@emotion/core'
import PropTypes from 'prop-types'

const accessCss = css`
  position: fixed;
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  border: none;
  background: none;
  z-index: 2;
`

const usePullDown = ({ isOn, pullDown }) => {
  useEffect(() => {
    if (pullDown) {
      const main = document.getElementById('root')
      main.style.transition = 'margin-top 0.5s ease-in'
      main.style.marginTop = isOn ? '500px' : '0'
    }
  }, [isOn, pullDown])
}

const Accessibility = ({ children, onClick, pullDown }) => {
  const [isOn, setIsOn] = useState(false)
  usePullDown({ isOn, pullDown })
  const toggle = () => setIsOn((val) => !val)
  return (
    <>
      <div css={accessCss}>
        <IconButton
          Icon={DiscoveryWheelchair}
          size="xl"
          emphasis={isOn ? 'high' : 'low'}
          onClick={() => {
            toggle()
            onClick?.()
          }}
        />
      </div>
      {children}
    </>
  )
}

Accessibility.propTypes = {
  children: PropTypes.shape({}),
}

export default Accessibility
